import type {
  FieldErrors,
  FieldNamesMarkedBoolean,
  FieldValues,
} from "react-hook-form";
import { useFormContext } from "react-hook-form";
import i18n from "../../../i18n";

type StepsType = {
  id: number;
  title: string;
}[];

export function Steps(): StepsType {
  const t = i18n.t.bind(i18n);
  const STEPS = [
    {
      id: 1,
      title: t("register.steps.cpf"),
    },
    {
      id: 2,
      title: t("register.steps.fullName"),
    },
    {
      id: 3,
      title: t("register.steps.contacts"),
    },
    {
      id: 4,
      title: t("register.steps.address"),
    },
    {
      id: 5,
      title: t("register.steps.password"),
    },
  ];

  return STEPS;
}

const isFieldValid = (
  fieldName: string,
  touchedFields: Partial<Readonly<FieldNamesMarkedBoolean<FieldValues>>>,
  errors: FieldErrors
): boolean => {
  const isFieldTouched = fieldName in touchedFields;
  const isValid = fieldName in errors;
  return isFieldTouched && !isValid;
};

const useFormValidity = (fieldName: string | string[]): boolean => {
  const {
    formState: { errors, dirtyFields },
  } = useFormContext();
  if (Array.isArray(fieldName)) {
    const validated = fieldName.map((field) =>
      isFieldValid(field, dirtyFields, errors)
    );
    return validated.every((field) => field);
  }
  return isFieldValid(fieldName, dirtyFields, errors);
};

export default useFormValidity;
